// extracted by mini-css-extract-plugin
module.exports = {"defaultPrompt":"style__defaultPrompt__Znszc","icon":"style__icon__0EViW","callToAction":"style__callToAction__zLhlX"};